module.exports = __webpack_public_path__ + "img/union-edit.be5e9844.svg";